import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { UsdtCurrency } from '@flipster/utils/constants/currency';

import { EventPeriod } from '../../component/event-period';
import { SeparatorTitle } from '../../component/separator-title';
import { DesktopTable, MobileTable, TableHeaderItemProps } from '../../component/table';
import { competitionTabsBunja } from '../../state';
import { lastChampionsBunja } from './state';
import { MobileTableRow, TableRow } from './table-row';

export const LastChampions = () => {
  const { hasLastCompetitionAtom, lastCompetitionChampionsAtom, lastCompetitionPeriodAtom } =
    useBunja(lastChampionsBunja);
  const hasLastCompetition = useAtomValue(hasLastCompetitionAtom);
  const { selectedEventTabValueAtom } = useBunja(competitionTabsBunja);
  const selectedEventTabValue = useAtomValue(selectedEventTabValueAtom);
  const isVolume = selectedEventTabValue === 'volume';
  const isRoi = selectedEventTabValue === 'roi';
  const lastCompetitionChampions = useAtomValue(lastCompetitionChampionsAtom);
  const lastCompetitionPeriod = useAtomValue(lastCompetitionPeriodAtom);

  const headerItems: Array<TableHeaderItemProps> = [
    { title: <FormattedMessage id='Common.r251201.Trader' />, align: 'left' },
    {
      title: <FormattedMessage id='Competition.r251215.Reward_symbol' values={{ symbol: UsdtCurrency }} />,
      align: 'right',
    },
    {
      title: isVolume ? (
        <FormattedMessage id='Competition.r251215.Volume_symbol' values={{ symbol: UsdtCurrency }} />
      ) : isRoi ? (
        <FormattedMessage id='Tmp.inseok.Roi_symbol' values={{ symbol: '%' }} />
      ) : (
        <FormattedMessage id='Competition.r251218.Pnl_symbol' values={{ symbol: UsdtCurrency }} />
      ),
      align: 'right',
    },
  ];

  const mobileHeaderItems: Array<TableHeaderItemProps> = [
    { title: <FormattedMessage id='Common.r251201.Trader' />, align: 'left' },
    {
      title: isVolume ? (
        <FormattedMessage id='Competition.r251215.Volume_symbol' values={{ symbol: UsdtCurrency }} />
      ) : isRoi ? (
        <FormattedMessage id='Tmp.inseok.Roi_symbol' values={{ symbol: '%' }} />
      ) : (
        <FormattedMessage id='Competition.r251218.Pnl_symbol' values={{ symbol: UsdtCurrency }} />
      ),
      align: 'right',
    },
  ];

  if (!hasLastCompetition || !lastCompetitionChampions) return null;

  return (
    <section>
      <SeparatorTitle
        colorSet='normal'
        title={<FormattedMessage id='Competition.r251215.Last_event_champions' />}
        description={<EventPeriod start={lastCompetitionPeriod.start} end={lastCompetitionPeriod.end} />}
        css={{ mb: 16 }}
      />
      <DesktopTable headerItems={headerItems} items={lastCompetitionChampions} Row={TableRow} />
      <MobileTable headerItems={mobileHeaderItems} items={lastCompetitionChampions} Row={MobileTableRow} />
    </section>
  );
};
